import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { ValidatorPattern } from '../utility/validators.pattern';
import { specialKeys } from '../utility/constants';

@Directive({
  selector: '[appPhoneNumber]',
})
export class AppPhoneNumberDirective {
  @Input() appPhoneNumber!: boolean;

  public regexPattern!: RegExp;
  private readonly specialKeys: Array<string> = specialKeys;

  constructor(private readonly el: ElementRef) {}

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const current: string = this.el.nativeElement.value;
    const next: string = current.concat(event.key);

    if (this.appPhoneNumber) {
      this.regexPattern = new RegExp(ValidatorPattern.NANPPhoneValidation);
    } else {
      this.regexPattern = new RegExp(ValidatorPattern.alphaNumerics);
    }

    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    const isPhone = this.appPhoneNumber;
    const maxLen = isPhone ? 12 : 10;
    const pattern = isPhone
      ? ValidatorPattern.PhoneValidationWith10NumbersHyphen
      : ValidatorPattern.alphaNumerics;

    if (next.length > maxLen || !new RegExp(pattern).test(event.key)) {
      event.preventDefault();
    }
  }
}
